import { bridgeAtom, store, tokenAtom } from '@/store';

import { timeAtom } from './sessionFinishTime.hook';

export const isTestUser = () => localStorage.getItem('testUser') === '1';

export function getUid() {
  const devUserSession = JSON.parse(localStorage.getItem('dialogue_shopify') || '{}');
  const prodUserSession = JSON.parse(localStorage.getItem('tls_NUN8930XF6') || '{}');

  if (devUserSession && devUserSession.uid) {
    return devUserSession.uid;
  }

  return prodUserSession.uid;
}

export const getSocketUrl = () => {
  const time = store.get(timeAtom);
  const token = store.get(tokenAtom);
  const { apiUrl, apiKey } = store.get(bridgeAtom);
  const urlParams = new URLSearchParams(window.location.search);
  const chatIdParam = urlParams.get('chatId');

  // chat is considered new if:
  // 1. there is no token, or time is 0
  // 2. there is no chatIdParam in the URL. Otherwise, we are trying to open an existing chat
  const isNewChat = (!token || time === 0) && !chatIdParam;

  const url = new URL(`${apiUrl}/websocket`);
  const params = new URLSearchParams({
    apiKey,
    newChat: isNewChat.toString(),
    customerId: window.loggedUserId || '',
  });

  if (token) {
    params.append('token', token);
  }

  url.search = params.toString();
  return url.toString();
};

export const getOriginalFetch = (): typeof fetch => {
  try {
    const iframe = document.createElement('iframe');
    document.body.appendChild(iframe);

    const originalFetch = iframe.contentWindow?.fetch?.bind(window);

    document.body.removeChild(iframe);

    return originalFetch || fetch;
  } catch (error) {
    console.warn('Error getting original fetch:', error);
    return fetch;
  }
};
